import CancelUpdateProfile from './cancel_update_profile';

export default class CancelUpdateEmailAddress extends CancelUpdateProfile {}
